var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAclaracionesBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7490",
    className: "cls-1",
    d: "M19.79,0H4.21C1.88,0,0,1.88,0,4.21v15.59c0,2.32,1.88,4.2,4.21,4.21h15.59c2.32,0,4.2-1.88,4.21-4.21V4.21c0-2.32-1.88-4.2-4.21-4.21ZM21.56,19.79c0,.97-.79,1.76-1.76,1.76H4.21c-.97,0-1.76-.79-1.76-1.76,0,0,0,0,0,0V4.21c0-.97.79-1.76,1.76-1.76,0,0,0,0,0,0h15.59c.97,0,1.76.79,1.76,1.76h0v15.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3332",
    className: "cls-1",
    x: 10.78,
    y: 5.81,
    width: 2.44,
    height: 7.96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3333",
    className: "cls-1",
    x: 10.78,
    y: 15.75,
    width: 2.44,
    height: 2.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAclaracionesBalken);
export default __webpack_public_path__ + "static/media/aclaraciones_BALKEN.48578a42d98eb6779d8f3797cfeedcaf.svg";
export { ForwardRef as ReactComponent };